/* @flow */

// used for origin= params in setup flow
export const origins = {
  CREATED_GROUP: 'created_group',
  SUBSCRIBED: 'subscribed',
  DIRECT: 'direct',
};
export type SetupOrigin = $Values<typeof origins>;
